import checkHasTrialPeriod from './checkHasTrialPeriod';
import checkHasValidStartDate from './checkHasValidStartDate';

export default function getTotalDueAmount({
  productType = 'charge',
  oneTimeTotalAmount = 0,
  recurringTotalAmount = 0,
  recurringAmountExcludingTax = 0,
  setupFeeAmount = 0,
  totalDiscountAmount = 0,
  taxEnabled = false,
  oneTimeFees = [],
  fees = [],
  startDate = null,
  trialPeriodDays = 0,
}) {
  if (productType === 'subscription') {
    let totalDueAmount;

    if (taxEnabled) {
      totalDueAmount = oneTimeTotalAmount + recurringAmountExcludingTax;
    } else {
      totalDueAmount = oneTimeTotalAmount + recurringTotalAmount;
    }

    totalDueAmount += setupFeeAmount;

    const hasValidStartDate = checkHasValidStartDate(startDate);
    const hasTrialPeriod = checkHasTrialPeriod(trialPeriodDays);

    if (hasTrialPeriod || hasValidStartDate) {
      totalDueAmount = oneTimeTotalAmount;

      if (oneTimeFees) {
        totalDueAmount += oneTimeFees.reduce((acc, fee) => acc + fee.amount, 0);
      }
    } else {
      if (fees) {
        totalDueAmount += fees.reduce((acc, fee) => acc + fee.amount, 0);
      }
    }

    totalDueAmount -= totalDiscountAmount;

    return totalDueAmount;
  } else {
    let totalDueAmount = oneTimeTotalAmount;

    if (fees) {
      totalDueAmount += fees.reduce((acc, fee) => acc + fee.amount, 0);
    }

    totalDueAmount += setupFeeAmount;

    totalDueAmount -= totalDiscountAmount;

    return totalDueAmount;
  }
}
